import $ from "jquery";

var zeroSuffix = "_zero";
var pluralSuffix = "_plural";
var twoSuffix = "_two";

function getTranslationWithPlurals(translationKey, pluralCount) {
  const { translations = {} } = window;
  if (pluralCount === 0 && translations[translationKey + zeroSuffix]) {
    return translations[translationKey + zeroSuffix];
  } else if (pluralCount === 2 && translations[translationKey + twoSuffix]) {
    return translations[translationKey + twoSuffix];
  } else if (pluralCount > 1 && translations[translationKey + pluralSuffix]) {
    return translations[translationKey + pluralSuffix];
  } else if (translations[translationKey]) {
    return translations[translationKey];
  }
  return translationKey;
}

function replaceVariablesInTranslation(translation, values) {
  return Object.keys(values).reduce(
    (accumulator, key) => accumulator.replace("{" + key + "}", values[key]),
    translation
  );
}

function translate(translationKey, values = {}) {
  const translation = getTranslationWithPlurals(translationKey, values.count);
  if (Object.keys(values).length) {
    return replaceVariablesInTranslation(translation, values);
  }
  return translation;
}

$.fn.translate = function (translationKey, values) {
  return this.text(translate(translationKey, values));
};

$.fn.translateHTML = function (translationKey, values) {
  return this.html(translate(translationKey, values));
};

export default translate;



// WEBPACK FOOTER //
// ./web/js/translate.js